'use client'
import { IconChevronDown } from '@tabler/icons-react'
import classNames from 'classnames'
import { AnimatePresence, easeInOut, motion } from 'framer-motion'
import { FC, ReactElement, useState } from 'react'

type AccordionProps = {
  headerComponent: ReactElement
  bodyComponent: ReactElement
  containerClassName?: { collapsed: string; open?: string }
  headerClassName?: { collapsed: string; open?: string }
  iconClassName?: { collapsed: string; open?: string }
}

const Accordion: FC<AccordionProps> = ({ headerComponent, bodyComponent, containerClassName, headerClassName, iconClassName }) => {
  const [isAccordionOpened, setIsAccordionOpened] = useState(false)

  const toggleAccordion = () => setIsAccordionOpened((prev) => !prev)

  return (
    <motion.div
      className={classNames('accordion', containerClassName?.collapsed, {
        [`${containerClassName?.open}`]: isAccordionOpened
      })}
    >
      <button
        onClick={toggleAccordion}
        className={classNames('w-full flex flex-row justify-between items-center', headerClassName?.collapsed, {
          [`${headerClassName?.open}`]: isAccordionOpened
        })}
      >
        {headerComponent}
        <IconChevronDown
          className={classNames({ 'rotate-180': isAccordionOpened }, 'min-w-6 transition', iconClassName?.collapsed, {
            [`${iconClassName?.open}`]: isAccordionOpened
          })}
        />
      </button>
      <AnimatePresence initial={false}>
        {isAccordionOpened && (
          <motion.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto' },
              collapsed: { opacity: 0, height: 0 }
            }}
            transition={{ duration: 0.18, ease: easeInOut }}
          >
            {bodyComponent}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  )
}

export default Accordion
